export default function isEmpty(value) {
  let none = value === null || value === undefined;

  if (none) return none;
  if (typeof value.size === 'number') return !value.size;
  if (typeof value.length === 'number') return !value.length;

  return false;
}
